import React, { useReducer, useCallback, useRef, useLayoutEffect } from 'react';
import { Box } from '@mui/material';
import { classes } from './styles';
import TabSelector from './Tabs/TabSelector';
import TabPanel from './Tabs/TabPanel';
import Searches from './Searches/Searches';
import CandidatePools from './CandidatePools/CandidatePools';
import { candidateSourcingReducer, initialCandidateSourcingState } from './candidateSourcingReducer';

const CandidateSourcing = () => {
  const [candidateSourcingState, candidateSourcingDispatch] = useReducer(
    candidateSourcingReducer,
    initialCandidateSourcingState
  );
  const tabIndicatorRef = useRef<HTMLElement[]>([]);

  const handleTabChange = useCallback((event: React.SyntheticEvent, tabValue: number) => {
    candidateSourcingDispatch({ type: 'SET_SELECTED_TAB', payload: tabValue });
  }, []);

  useLayoutEffect(() => {
    candidateSourcingDispatch({
      type: 'SET_INDICATOR_WIDTH',
      payload: tabIndicatorRef?.current[candidateSourcingState.selectedTab]?.clientWidth || 0
    });
  }, [candidateSourcingState.selectedTab]);

  return (
    <Box sx={classes.pageContainer}>
      <Box sx={classes.pageHeader}>
        <h1>Agentic :ENGAGE</h1>
      </Box>
      <TabSelector
        candidateSourcingState={candidateSourcingState}
        handleTabChange={handleTabChange}
        tabIndicatorRef={tabIndicatorRef}
      />
      <TabPanel tabValue={candidateSourcingState.selectedTab} index={0}>
        <Searches />
      </TabPanel>
      <TabPanel tabValue={candidateSourcingState.selectedTab} index={1}>
        <CandidatePools />
      </TabPanel>
    </Box>
  );
};

export default CandidateSourcing; 
